import { bus_laixe } from "../../../models/response/bus/bus_laixe";
import {
	eBusLaiXeActionTypeIds,
	IBusLaiXeChangeSelectedIds,
	IBusLaiXeCloseConfirm,
	IBusLaiXeCloseDetail,
	IBusLaiXeDeleteErr,
	IBusLaiXeDeleteStart,
	IBusLaiXeDeleteSuccess,
	IBusLaiXeLoadErr,
	IBusLaiXeLoadStart,
	IBusLaiXeLoadSuccess,
	IBusLaiXeSaveErr,
	IBusLaiXeSaveStart,
	IBusLaiXeSaveSuccess,
	IBusLaiXeShowConfirm,
	IBusLaiXeShowDetail
} from "../../action-types/bus/IBusLaiXeActionTypes";

export const busLaiXeActions = {
	loadBusLaiXeStart: (dm_coso_id: number): IBusLaiXeLoadStart => {
		return {
			type: eBusLaiXeActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadBusLaiXeSuccess: (data: bus_laixe[]): IBusLaiXeLoadSuccess => {
		return {
			type: eBusLaiXeActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusLaiXeError: (message: string): IBusLaiXeLoadErr => {
		return {
			type: eBusLaiXeActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	showBusLaiXeDetail: (data?: bus_laixe): IBusLaiXeShowDetail => {
		return {
			type: eBusLaiXeActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusLaiXeDetail: (): IBusLaiXeCloseDetail => {
		return {
			type: eBusLaiXeActionTypeIds.CLOSE_DETAIL
		}
	},
	showBusLaiXeConfirm: (): IBusLaiXeShowConfirm => {
		return {
			type: eBusLaiXeActionTypeIds.SHOW_CONFIRM
		}
	},
	closeBusLaiXeConfirm: (): IBusLaiXeCloseConfirm => {
		return {
			type: eBusLaiXeActionTypeIds.CLOSE_CONFIRM
		}
	},
	changeBusLaiXeSelectedIds: (ids: number[]): IBusLaiXeChangeSelectedIds => {
		return {
			type: eBusLaiXeActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	deleteBusLaiXeStart: (id: number): IBusLaiXeDeleteStart => {
		return {
			type: eBusLaiXeActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusLaiXeSuccess: (): IBusLaiXeDeleteSuccess => {
		return {
			type: eBusLaiXeActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusLaiXeErr: (message: string): IBusLaiXeDeleteErr => {
		return {
			type: eBusLaiXeActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	saveBusLaiXeStart: (data: bus_laixe): IBusLaiXeSaveStart => {
		return {
			type: eBusLaiXeActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusLaiXeSuccess: (): IBusLaiXeSaveSuccess => {
		return {
			type: eBusLaiXeActionTypeIds.SAVE_SUCCESS
		}
	},
	saveBusLaiXeError: (message: string): IBusLaiXeSaveErr => {
		return {
			type: eBusLaiXeActionTypeIds.SAVE_ERR,
			payload: message
		}
	}
}
